import { GraphQLError } from 'graphql'
import { ApolloLink } from '@apollo/client'

import { ParsedGraphQLError } from '@/types/graphql'
import { parseError } from '@/utils'

export default new ApolloLink((operation, forward) =>
  forward(operation).map((response) => {
    // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
    // https://github.com/apollographql/apollo-client/issues/9292
    if (response?.errors?.length) {
      // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
      const parsedError = parseError(response.errors[0])
      const parsedResponse = parsedError?.response
      const errorData = parsedResponse?.data
      const status = parsedResponse?.status

      if (errorData) {
        const parsedGraphQLError: ParsedGraphQLError = new GraphQLError('')
        parsedGraphQLError.parsedError = errorData
        parsedGraphQLError.status = status

        return {
          ...response,
          // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
          errors: [...response.errors, parsedGraphQLError],
        }
      }

      if (typeof parsedError === 'string') {
        const parsedGraphQLError: ParsedGraphQLError = new GraphQLError('')
        parsedGraphQLError.parsedError = {
          baseErrors: [parsedError],
        }

        return {
          ...response,
          // @ts-expect-error response.errors is valid in some cases, upgrading apollo client broke
          errors: [...response.errors, parsedGraphQLError],
        }
      }

      return response
    }

    return response
  })
)
